import { pick, groupBy, map, filter, sortBy, values, mergeWithKey, reduce, pipe, __, prop, uniq } from 'ramda';
import { permissionDetails } from './permission-mapping';
export default getPermissions;
function getPermissions(aispDetails, accountNumberFormat) {
  var permissions = aispDetails.get('permissions');
  var concatValues = function concatValues(key, acc, value) {
    return key == 'description' ? "".concat(acc, "; ").concat(value) : value;
  };
  var transform = pipe(addImpliedBasicPermissions, uniq, pick(__, permissionDetails(accountNumberFormat)), filter(function (i) {
    return i.description !== '';
  }), values, sortBy(prop('order')), map(pick(['header', 'description'])), groupBy(prop('header')), map(reduce(mergeWithKey(concatValues), {})), values);
  return transform(permissions);
}
function addImpliedBasicPermissions(tokens) {
  return tokens.reduce(addBasicPermission, []);
}
function addBasicPermission(acc, next) {
  if (next.slice(-6) === 'Detail') {
    acc.push(next.replace('Detail', 'Basic'));
  }
  if (next.slice(-8) === 'Detailed') {
    acc.push(next.replace('Detailed', ''));
  }
  acc.push(next);
  return acc;
}